import React from 'react';

const Header = ({ keyword, handleChange, handleSubmit }) => {
  return (
    <header className="gb-header">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xs-12 col-md-6 form-search-container">
            <div className="form-group">
              <input
                type="search"
                className="gb-search"
                placeholder="eg. Fyodor Dostoyevsky"
                value={keyword}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-xs-12 col-md-6 form-submit-container">
            <div className="form-group">
              <button type="submit" className="button">
                Search
              </button>
            </div>
          </div>
        </div>
      </form>
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.jsx